import { $t } from '@/plugins/i18n';

export const rules = {
  password: [
    v => !!v || $t('validation.password.required'),
    v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/.test(v) || $t('validation.password.valid'),
  ],

  passwordConfirmation: [
    function equal(password) {
      return password === this.password;
    },
  ],

  email: [
    v => !!v || $t('validation.email.required'),
    v => /.+@.+/.test(v) || $t('validation.email.valid'),
  ],

  zipcode: [
    v => !!v || $t('validation.zipcode.required'),
    v => /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(v) || $t('validation.zipcode.valid'),
  ],

  houseNumber: [
    v => !!v || $t('validation.houseNumber.required'),
    v => /^\d+$/.test(v) || $t('validation.houseNumber.valid'),
  ],

  meterNumber: [
    v => !!v || $t('validation.meterNumber.required'),
    v => /^\d{4}$/.test(v) || $t('validation.meterNumber.valid'),
  ],
};

export default rules;
